<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.location.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/master/location"><span>{{$t('tlt.location')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/location/edit"><span>{{$t('tlt.location.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary" type="button" v-on:click="MMFbackToList('location')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>Cancel</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('location')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.code')}}:</label>
                                <input class="form-control form-control-sm" v-model="code" type="text">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.name')}}:</label>
                                <input class="form-control form-control-sm" v-model="locName" type="text">
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.type')}}:</label>
                                <select class="form-control form-control-sm" v-model="locType">
                                        <option value="-1">{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="E">{{ $t("lbl.location.enterprise") }}</option>
                                        <option value="S">{{ $t("lbl.location.site") }}</option>  
                                        <option value="A">{{ $t("lbl.location.area") }}</option>                                      
                                        <option value="W">{{ $t("lbl.location.workCenter") }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.active')}}:</label>
                                <select class="form-control form-control-sm" v-model="active">
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
 </template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions } from "vuex";
import {fields}  from "@/model/master/Location";

const { mapFields } = createHelpers({
  getterType: 'location/getField',
  mutationType: 'location/updateField',
});
export default {
  computed: {
    ...mapFields(fields),
  },
  mounted(){
      this.MMFCheckState('location');
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"])
  }
};
</script>